/*
 * Interface to define a banner message
 */
export interface BannerMessage {
  text: String;
  title?: String;
  href?: String;
  category: BannerMessageType;
}

/**
 * Enum to define the banner message types supported
 */
export enum BannerMessageType {
  A_LA_UNE    = "À la une",
  DECRYPTAGE  = "Décryptage",
  INFO_FLASH  = "Info Flash",
  INFO_LETTRE = "Infolettre",
}
